// extracted by mini-css-extract-plugin
module.exports = {"draftmodal":"draftsave_draftmodal__2SUzr","insertStyles":"draftsave_insertStyles__2CU7E","cancel":"draftsave_cancel__Ai9sQ","content":"draftsave_content__1_ejs"};